import React, { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { student, UpdateStudentDiscount } from "../../../api/StudentServices";
import { getRteStudent } from "../../../api/RteService";
import { closeModal, ToastMain, SweetAlertShow } from "../../master/Master";
import { BusRoute, BusStudentCreate, GetBus } from "../../../api/BusService";
import { imgBaseUrl } from "../../../api/api";

const Emi = ({ data, getStudent }) => {
  const emi = data?.student?.emi || [];
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");

  // permissions for user role
return (
    <div className="card">
      <div className="card-body">
        <div className="table-responsive">
          <h5 className="mb-3">EMI Details</h5>
          <table className="table ">
            <thead className="table-primary text-center">
              <tr>
                <th>Date</th>
                <th>Amount (₹)</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {emi.length > 0 ? (
                emi.map((item) => (
                  <tr key={item.id}>
                    <td>{item.emi_date}</td>
                    <td>₹{item.emi_amount}</td>
                    <td>
                      <span
                        className={`badge ${
                          item.emi_payment_status === "Due"
                            ? "bg-danger"
                            : "bg-success"
                        }`}
                      >
                        {item.emi_payment_status}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center text-muted">
                    No EMI Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Emi;
